<script>
    import WebAppPrompt from '$lib/components/WebAppPrompt.svelte';
</script>

<footer class="mb-20 p-4 text-center">
    <WebAppPrompt />
</footer>
